import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Dropdown from '../Components/Dropdown'
import DropdownFlat from '../Components/DropdownFlat'
import { patchUpdateInspectionStatus, getCallLineItemDetailsById, getAllDocumentsUploadedByInpsector, createReworkReofferCallItem, uploadInspectionCSMTLink } from '../store/actions/inspectionActions'
import { getPODetails, getPOSearch, postSaveStagesForLineItemPO, postEditStagesForLineItemPO } from '../store/actions/poDetailsActions'
import { getInspectionStatusMaster } from "../store/actions/masterActions";
import { uploadInspectionFiles, downloadFile } from '../store/actions/fileActions.js'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import AuthHandlerInstance from '../Classes/AuthHandler'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FileVersionModal from '../Components/FileVersionModal';
import env from '../ENV';
import swal from '@sweetalert/with-react'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import toast from 'react-hot-toast';
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class InspectorDetails extends React.Component {

    constructor(props) {
        super(props);
        console.log(this.props, '++++++++++++++++++++++')
        const poID = this.props.location.state.data
        this.state = {
            isUpdateStatus: false,
            poid: poID,
            callId: this.props.location.state.callNo,
            polineitemId: this.props.location.state.polineitemId,
            IndexLineId: this.props.location.state.IndexLineId,
            InspectionLineItemID: this.props.location.state.InspectionLineItemID,
            InspectionId: this.props.location.state.InspectionId,
            modal: false,
            dropdown: "",
            Status: [],
            backgroundColor: "#fff",
            opacity: "",
            comments: '',
            AcceptedQuantity: '0',
            RejectedQuantity: '0',
            ReworkReofferQty: '0',
            ReworkComplainceQty: '0',
            SupplierNotReadyQty: '0',
            InspectionNotCompletedQty: '0',
            InspectionQuantity: '0',
            nextPlannedDate: '',
            InspectedQty: 0,
            files: [],
            documentTypeIds: [],
            uploadedId: null,
            OpenVersionModal: false,
            selected: "",
            docarr: [
                { documentName: "Test Certificate", documentTypeId: 25 },
                { documentName: "Test Reports", documentTypeId: 26 },
                { documentName: "NDT reports", documentTypeId: 29 },
                { documentName: "Dimensional Reports", documentTypeId: 30 },
                { documentName: "Q-Notification", documentTypeId: 89 },
                { documentName: "Rework List", documentTypeId: 90 },
            ],
            // buttonvisibility: false,
            CSMTLink: '',
            inspectionTypes: [
                {
                    id: 0, name: "Stage",
                },
                {
                    id: 1, name: "Final",
                },
            ],
            inspectionType: 0,
        }
        this.modal = this.modal.bind(this);
        this.comments = this.comments.bind(this);
        this.handleAcceptedQuantity = this.handleAcceptedQuantity.bind(this);
        this.handleReworkReofferQty = this.handleReworkReofferQty.bind(this);
        this.handleReworkComplainceQty = this.handleReworkComplainceQty.bind(this);
        this.handleSupplierNotReadyQty = this.handleSupplierNotReadyQty.bind(this);
        this.handleInspectionNotCompletedQTY = this.handleInspectionNotCompletedQTY.bind(this);
        this.nextPlannedDate = this.nextPlannedDate.bind(this);
        this.OpenVersionModal = this.OpenVersionModal.bind(this);
        this.handleCSMTLink = this.handleCSMTLink.bind(this);

    }

    modal() {
        this.setState({ modal: !this.state.modal });

        if (this.state.modal == true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )

        }
    }

    validateURL(url) {
        var urlregex = new RegExp("^(http|https|ftp)\://([a-zA-Z0-9\.\-]+(\:[a-zA-Z0-9\.&amp;%\$\-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(\:[0-9]+)*(/($|[a-zA-Z0-9\.\,\?\'\\\+&amp;%\$#\=~_\-]+))*$");
        return urlregex.test(url);
    }

    async OpenVersionModal(uploadedId) {
        let versionList = [];


        // if(this.state.OpenVersionModal ==false){
        //     this.setState({opacity:"0.2"})
        // }else{
        //     this.setState({opacity:""})
        // }
        let stateVal = this.state.OpenVersionModal;
        this.setState({ OpenVersionModal: !stateVal, uploadedId: uploadedId });

    }

    updateStatus = async () => {
        const { isUpdateStatus } = this.state
        this.setState({ isUpdateStatus: true })
        let UserId = AuthHandlerInstance.getUserID()
        console.log(this.state.selected, this.state.comments, this.state.AcceptedQuantity, this.state.nextPlannedDate, this.props.inspectionReducerData.inspectionLineItemDetailsByCallID[0], 'update-status')
        // return false;

        let totalQty = 0
        let AcceptedQuantity = this.state.AcceptedQuantity ? this.state.AcceptedQuantity : 0
        let ReworkReofferQty = this.state.ReworkReofferQty ? this.state.ReworkReofferQty : 0
        let RejectedQuantity = this.state.RejectedQuantity ? this.state.RejectedQuantity : 0
        let SupplierNotReadyQty = this.state.SupplierNotReadyQty ? this.state.SupplierNotReadyQty : 0
        let ReworkComplainceQty = this.state.ReworkComplainceQty ? this.state.ReworkComplainceQty : 0
        let InspectionNotCompletedQty = this.state.InspectionNotCompletedQty ? this.state.InspectionNotCompletedQty : 0

        totalQty = (parseFloat(AcceptedQuantity) + parseFloat(ReworkReofferQty) + parseFloat(RejectedQuantity) + parseFloat(SupplierNotReadyQty) + parseFloat(ReworkComplainceQty) + parseFloat(InspectionNotCompletedQty))

        console.log(totalQty, 'totalQty')

        let callItem = this.props.inspectionReducerData.inspectionLineItemDetailsByCallID[0].find((item) => item.InspectionCallItemId === this.state.InspectionLineItemID)

        if (callItem.InspectionQuantity !== totalQty) {
            let errorMessage = `Sum of total Quantity is not equal to Inspection Quantity(${callItem.InspectionQuantity}). Please revise it again`
            swal(errorMessage, { icon: "error" })
            return false;
        }
        console.log("lkjhgfcv bnds", this.state.callId, callItem.InspectionCallId)
        if (this.state.ReworkReofferQty > 0) {
            let reworkData = {
                UserId: UserId,
                ParentCallId: this.state.InspectionLineItemID,
                PurchaseOrderLineId: callItem.PurchaseOrderLineId,
                QATemplateStageId: callItem.QATemplateStageId,
                TotalQuantity: this.state.ReworkReofferQty,
                POSAPId: callItem.POSAPId,
                poId: callItem.PurchaseOrderId,
                inspectorId: callItem.InspectorId,
                InspectionId: this.state.InspectionId,
                CallItemType: 'RW',
                CallID: callItem.CallID,
                CallIDData: this.state.callId,
                inspectionType: this.state.inspectionType,
                Status: 'Inspection completed, Rework Required, Reoffer',

            }

            await this.props.createReworkReofferCallItem(this.state.InspectionLineItemID, reworkData)
        }

        if (this.state.RejectedQuantity > 0) {
            let reworkData = {
                UserId: UserId,
                ParentCallId: this.state.InspectionLineItemID,
                PurchaseOrderLineId: callItem.PurchaseOrderLineId,
                QATemplateStageId: callItem.QATemplateStageId,
                TotalQuantity: this.state.RejectedQuantity,
                POSAPId: callItem.POSAPId,
                poId: callItem.PurchaseOrderId,
                inspectorId: callItem.InspectorId,
                InspectionId: this.state.InspectionId,
                CallItemType: 'RJ',
                CallID: callItem.CallID,
                CallIDData: this.state.callId,
                inspectionType: this.state.inspectionType,
                Status: 'Rejected',

            }

            await this.props.createReworkReofferCallItem(this.state.InspectionLineItemID, reworkData)
        }

        if (this.state.SupplierNotReadyQty > 0) {
            let reworkData = {
                UserId: UserId,
                ParentCallId: this.state.InspectionLineItemID,
                PurchaseOrderLineId: callItem.PurchaseOrderLineId,
                QATemplateStageId: callItem.QATemplateStageId,
                TotalQuantity: this.state.SupplierNotReadyQty,
                POSAPId: callItem.POSAPId,
                poId: callItem.PurchaseOrderId,
                inspectorId: callItem.InspectorId,
                InspectionId: this.state.InspectionId,
                CallItemType: 'RV',
                CallID: callItem.CallID,
                CallIDData: this.state.callId,
                inspectionType: this.state.inspectionType,
                Status: 'Incomplete call, Supplier Not ready,Partial/ No item can be inspected',

            }

            await this.props.createReworkReofferCallItem(this.state.InspectionLineItemID, reworkData)
        }

        if (this.state.InspectionNotCompletedQty > 0) {
            let reworkData = {
                UserId: UserId,
                ParentCallId: this.state.InspectionLineItemID,
                PurchaseOrderLineId: callItem.PurchaseOrderLineId,
                QATemplateStageId: callItem.QATemplateStageId,
                TotalQuantity: this.state.InspectionNotCompletedQty,
                POSAPId: callItem.POSAPId,
                poId: callItem.PurchaseOrderId,
                inspectorId: callItem.InspectorId,
                InspectionId: this.state.InspectionId,
                CallItemType: 'RI',
                CallID: callItem.CallID,
                CallIDData: this.state.callId,
                inspectionType: this.state.inspectionType,
                Status: 'Incomplete call, No item can be inspected',

            }

            await this.props.createReworkReofferCallItem(this.state.InspectionLineItemID, reworkData)
        }

        if (this.state.ReworkComplainceQty > 0) {
            let reworkData = {
                UserId: UserId,
                ParentCallId: this.state.InspectionLineItemID,
                PurchaseOrderLineId: callItem.PurchaseOrderLineId,
                QATemplateStageId: callItem.QATemplateStageId,
                TotalQuantity: this.state.ReworkComplainceQty,
                POSAPId: callItem.POSAPId,
                poId: callItem.PurchaseOrderId,
                inspectorId: callItem.InspectorId,
                InspectionId: this.state.InspectionId,
                CallItemType: 'RC',
                CallID: callItem.CallID,
                CallIDData: this.state.callId,
                inspectionType: this.state.inspectionType,
                Status: 'Inspection completed, Rework Required, Compliance, Reoffer',

            }

            await this.props.createReworkReofferCallItem(this.state.InspectionLineItemID, reworkData)
        }

        if (AcceptedQuantity > 0) {
            let status = "Closed and Accepted"
                + (this.state.ReworkReofferQty > 0 ? ", Rework Reoffer" : "")
                + (this.state.RejectedQuantity > 0 ? ", Rejected" : "")
                + (this.state.SupplierNotReadyQty > 0 ? ", Supplier Not ready" : "")
                + (this.state.InspectionNotCompletedQty > 0 ? ", Incomplete" : "")
                + (this.state.ReworkComplainceQty > 0 ? ", Rework Compliance" : "")
            let body = {
                UserId: UserId,
                inspectionCallId: this.state.InspectionLineItemID,
                AcceptedQuantity: this.state.AcceptedQuantity,
                InspectionQuantity: this.props.inspectionReducerData && this.props.inspectionReducerData.inspectionLineItemDetailsByCallID.length > 0 && this.props.inspectionReducerData.inspectionLineItemDetailsByCallID[0][0].InspectionQuantity,
                comments: this.state.comments,
                poId: callItem.PurchaseOrderId,
                inspectorId: callItem.InspectorId,
                InspectionId: this.state.InspectionId,
                status: status,
                nextPlannedDate: this.state.nextPlannedDate,
                CallIDData: this.state.callId,
                QATemplateStageId: callItem.QATemplateStageId,
                inspectionType: this.state.inspectionType,
            }
            await this.props.patchUpdateInspectionStatus(this.state.InspectionLineItemID, body)
        } else {
            let status = "Closed"
                + (this.state.ReworkReofferQty > 0 ? ", Rework Reoffer" : "")
                + (this.state.RejectedQuantity > 0 ? ", Rejected" : "")
                + (this.state.SupplierNotReadyQty > 0 ? ", Supplier Not ready" : "")
                + (this.state.InspectionNotCompletedQty > 0 ? ", Incomplete" : "")
                + (this.state.ReworkComplainceQty > 0 ? ", Rework Compliance" : "")
            let body = {
                UserId: UserId,
                inspectionCallId: this.state.InspectionLineItemID,
                AcceptedQuantity: this.state.AcceptedQuantity,
                InspectionQuantity: this.props.inspectionReducerData && this.props.inspectionReducerData.inspectionLineItemDetailsByCallID.length > 0 && this.props.inspectionReducerData.inspectionLineItemDetailsByCallID[0][0].InspectionQuantity,
                comments: this.state.comments,
                poId: callItem.PurchaseOrderId,
                inspectorId: callItem.InspectorId,
                InspectionId: this.state.InspectionId,
                status: status,
                nextPlannedDate: this.state.nextPlannedDate,
                CallIDData: this.state.callId,
                QATemplateStageId: callItem.QATemplateStageId,
                inspectionType: this.state.inspectionType,
            }
            await this.props.patchUpdateInspectionStatus(this.state.InspectionLineItemID, body)
        }

        console.log(this.state.ReworkReofferQty, 'reworkQTY')

        //await this.props.patchUpdateInspectionStatus(this.state.InspectionLineItemID, body)
        //    this.props.getinspectionLineItemDetailsByCallID(this.state.callId)
        //await this.props.getCallLineItemDetailsById(this.state.InspectionLineItemID)
        this.setState({ isUpdateStatus: false})
        await this.modal()
        await window.location.reload()
    }

    handleSelect = (e) => {
        // console.log("drop", e.target);
        // console.log("drop", e.target.key);
        // var obj = {
        //   key: e,
        //   value: e.target.value
        // }
        // var dropdown_arr = this.state.selected.push(obj)
        this.setState({
            selected: e.target.value
        })
        //alert(JSON.parse(e))
    }

    comments(event) { this.setState({ comments: event.target.value }) }

    checkTotalQuantity = async (type, qty, totalQty) => {
        let AcceptedQuantity = this.state.AcceptedQuantity
        let RejectedQuantity = this.state.RejectedQuantity
        let ReworkReofferQty = this.state.ReworkReofferQty
        let ReworkComplainceQty = this.state.ReworkComplainceQty
        let SupplierNotReadyQty = this.state.SupplierNotReadyQty
        let InspectionNotCompletedQty = this.state.InspectionNotCompletedQty

        if (type === 'accept') {
            AcceptedQuantity = qty
        }
        if (type === 'reject') {
            RejectedQuantity = qty
        }
        if (type === 'rw') {
            ReworkReofferQty = qty
        }
        if (type === 'rc') {
            ReworkComplainceQty = qty
        }
        if (type === 'rv') {
            SupplierNotReadyQty = qty
        }
        if (type === 'inc') {
            InspectionNotCompletedQty = qty
        }

        let total = AcceptedQuantity + RejectedQuantity + ReworkReofferQty + ReworkComplainceQty + SupplierNotReadyQty + InspectionNotCompletedQty

        if (total <= totalQty) {
            return true
        } else {
            return false
        }
    }

    handleCSMTLink(e) {
        this.setState({ CSMTLink: e.target.value })
    }

    handleAcceptedQuantity(event, inspectionQuantity, unit) {
        console.log("Pending", event.target.value, "insQuant=", inspectionQuantity)

        if (event.target.value > inspectionQuantity) {
            let errorMessage = `Entered Quantity : ${event.target.value + " " + unit} is greater than Inspection Quantity(${inspectionQuantity + " " + unit}). Please revise it again`
            swal(errorMessage, { icon: "error" })
            event.target.value = ''
        }

        this.setState({ AcceptedQuantity: event.target.value })
    }

    handleRejectedQuantity = async (event, inspectionQuantity, unit) => {
        let AcceptedQuantity = this.state.AcceptedQuantity
        let RejectedQuantity = this.state.RejectedQuantity
        let ReworkReofferQty = this.state.ReworkReofferQty
        let ReworkComplainceQty = this.state.ReworkComplainceQty
        let SupplierNotReadyQty = this.state.SupplierNotReadyQty
        let InspectionNotCompletedQty = this.state.InspectionNotCompletedQty

        let total = AcceptedQuantity + RejectedQuantity + ReworkReofferQty + ReworkComplainceQty + SupplierNotReadyQty + InspectionNotCompletedQty

        if (total <= inspectionQuantity) {

        }

        this.setState({ RejectedQuantity: event.target.value })

    }

    handleReworkReofferQty(event, inspectionQuantity, unit) {
        this.setState({ ReworkReofferQty: event.target.value })
    }

    handleReworkComplainceQty(event, inspectionQuantity, unit) {
        this.setState({ ReworkComplainceQty: event.target.value })
    }

    handleSupplierNotReadyQty(event, inspectionQuantity, unit) {
        this.setState({ SupplierNotReadyQty: event.target.value })
    }
    handleInspectionNotCompletedQTY(event, inspectionQuantity, unit) {
        this.setState({ InspectionNotCompletedQty: event.target.value })
    }
    nextPlannedDate(event) { this.setState({ nextPlannedDate: event.target.value }) }


    componentDidMount = async () => {
        console.log(this.state.callId)
        // this.props.getinspectionLineItemDetailsByCallID(this.state.callId)
        await this.datasync()
    }

    datasync = async () => {
        await this.props.getCallLineItemDetailsById(this.state.InspectionLineItemID, this.state.InspectionId)
        await this.props.getAllDocumentsUploadedByInpsector(this.state.InspectionLineItemID)
        await this.props.getInspectionStatusMaster()
        // await this.props.getPODetails(this.state.poid)

        let callItem = this.props.inspectionReducerData.inspectionLineItemDetailsByCallID[0].find((item) => item.InspectionCallItemId === this.state.InspectionLineItemID)

        if (callItem) {
            this.setState({
                InspectedQty: callItem.InspectionQuantity,
                CSMTLink: callItem.CSMTLink,
                inspectionType : callItem.QATemplateStageId == 0 ? 'Final' : 'Stage'
            })
            console.log(callItem.InspectionQuantity, 'callItem.InspectionQuantity')
        }
    }

    // handleFileInput = (event, DocumentTypeId,documentUploadId) => { 
    handleFileInput = (event, documentTypeId, documentUploadId) => {
        let files = [...this.state.files]
        files.push(event.target.files[0])
        let documentTypeIds = [...this.state.documentTypeIds]
        documentTypeIds.push(documentTypeId)
        this.setState({ files, documentTypeIds })

    }

    saveFiles = async () => {
        console.log(this.state.files, this.state.documentTypeIds, this.state.InspectionLineItemID, 'files')
        await this.props.uploadInspectionFiles(this.state.files, this.state.documentTypeIds, this.state.InspectionLineItemID)
        // this.props.getinspectionLineItemDetailsByCallID(this.state.callId)
        await this.props.getCallLineItemDetailsById(this.state.InspectionLineItemID)
        await this.props.getAllDocumentsUploadedByInpsector(this.state.InspectionLineItemID)
    }

    saveCSMTLink = async () => {
        let CSMTLink = this.state.CSMTLink
        let CallIDData = this.state.callId
        let UserId = AuthHandlerInstance.getUserID()
        if (this.validateURL(CSMTLink)) {
            let data = {
                CSMTLink: CSMTLink,
                CallIDData: this.state.callId,
                UserId: UserId
            }
            await this.props.uploadInspectionCSMTLink(data, this.state.InspectionLineItemID)
            toast.success(`CSMT Link saved successfully`, {
                duration: 1000
            });
            await this.datasync()
        } else {
            swal('Please enter a valid CSMT link', { icon: "error" })
        }
    }

    downloadFile = (uploadid) => {
        this.props.downloadFile(uploadid)
    }

    handleInspectionTypeChange = (e, index) => {
        this.setState({ inspectionType: e.target.value })
    }



    render() {

        console.log(this.props.inspectionReducerData, "______________________")
        // console.log(this.props.inspectionReducerData.documentData.recordset,"========================================================")
        // console.log(this.state.polineitemId)
        var roles = AuthHandlerInstance.getRoles()
        var Status = []
        // const po = this.props.poDetails.poDetails.poId
        // const poID = this.props.poDetails.poDetails.poSapCode

        var documentUploadId25 = ''
        var documentUploadId26 = ''
        var documentUploadId29 = ''
        var documentUploadId30 = ''

        if (this.props.inspectionReducerData && this.props.inspectionReducerData.inspectionLineItemDetailsByCallID.length > 0 && this.props.inspectionReducerData.documentData.recordset) {
            if (this.props.inspectionReducerData.documentData.recordset.length > 0) {
                if (this.props.inspectionReducerData.documentData.recordset[0]) documentUploadId25 = this.props.inspectionReducerData.documentData.recordset[0].DocumentUploadId
                if (this.props.inspectionReducerData.documentData.recordset[1]) documentUploadId26 = this.props.inspectionReducerData.documentData.recordset[1].DocumentUploadId
                if (this.props.inspectionReducerData.documentData.recordset[2]) documentUploadId29 = this.props.inspectionReducerData.documentData.recordset[2].DocumentUploadId
                if (this.props.inspectionReducerData.documentData.recordset[3]) documentUploadId30 = this.props.inspectionReducerData.documentData.recordset[3].DocumentUploadId

            }
        }

        this.props.masterReducerData && this.props.masterReducerData.inspectionStatus && this.props.masterReducerData.inspectionStatus.recordset && this.props.masterReducerData.inspectionStatus.recordset.map((value, index) => (
            Status.push({ value: value.StatusId, label: value.StatusName })
        ))

        var inspectionLineItemDetailsByCallID = []
        this.props.inspectionReducerData && this.props.inspectionReducerData.inspectionLineItemDetailsByCallID.length > 0 && this.props.inspectionReducerData.inspectionLineItemDetailsByCallID[0].map((value, index) => {
            // console.log(value.PurchaseOrderLineId, this.state.polineitemId)
            if (value.PurchaseOrderLineId == this.state.polineitemId) {
                inspectionLineItemDetailsByCallID.push(value)
            }

            // if(value.Status!="Accepted"){
            //     let buttonvisibility= true
            //     this.setState({buttonvisibility})
            // }

        })

        console.log(this.state.polineitemId, '_+_+__')

        // this.props.inspectionReducerData && this.props.inspectionReducerData.inspectionLineItemDetailsByCallID.length>0 && this.props.inspectionReducerData.inspectionLineItemDetailsByCallID[1].map((value,index)=>{
        //     inspectionLineItemDetailsByCallID1.push(value)
        // })

        return (

            <div className="Container-fluid pr-4" >
                {this.state.uploadedId && <FileVersionModal uploadedId={this.state.uploadedId} OpenVersionModal={(documentUploadId25) => this.OpenVersionModal(documentUploadId25)} />}

                {/* ----Modal Start----- */}

                <Modal isOpen={this.state.modal} className="modal-lg">
                    <div className={"modal-bg" + (this.state.modal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Update Inspection Status</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            {
                                inspectionLineItemDetailsByCallID.map((value, index) => (

                                    <ModalBody Style="modal-body modalbodysWide">

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col "><b>PO No : </b></div>
                                                    <div className="col">{value.POSAPId}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>Item No :</b></div>
                                                    <div className="col ">{value.POLineItemSAPCode}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>PO Date :</b></div>
                                                    <div className="col ">{dateFormater(value.POCreationDate)}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>PO Delivery Date :</b></div>
                                                    <div className="col ">{dateFormater(value.PODeliveryDate)}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>Supplier Name :</b></div>
                                                    <div className="col ">{value.VendorName}</div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="row ">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>Inspection Call No :</b></div>
                                                    <div className="col ">{value.InspectionCallNo}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row ">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>PO Quantity :</b></div>
                                                    <div className="col ">{value.POLineItemQuantity + " " + value.Unit}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row ">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>Quantity to Inspect :</b></div>
                                                    <div className="col ">{value.InspectionQuantity + " " + value.Unit}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row ">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>Location :</b></div>
                                                    <div className="col ">{value.Location}</div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="row ">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>Proposed Inspection Date :</b></div>
                                                    <div className="col ">{dateFormater(value.VendorProposedDate)}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row ">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>Stage / Final :</b></div>
                                                    <div className="col ">
                                                        <DropdownFlat defaultopt="Select Type" data={this.state.inspectionTypes} selectedValue={this.state.inspectionType} actions={(e) => { this.handleInspectionTypeChange(e) }} keyObjName={"name"} valueObjName={"name"} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row ">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>Status :</b></div>
                                                    <div className="col ">{value.Status}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row ">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>Item Description :</b></div>
                                                    <div className="col ">{value.POLineItemDescription}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row ">
                                            <div className="col ">
                                                <div className="row">
                                                    <div className="col "><b>Inspector Name :</b></div>
                                                    <div className="col ">{value.InspectorName}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row ">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col "><b>Allocated Inspection Date :</b></div>
                                                    <div className="col ">{dateFormater(value.InspectionDate)}</div>
                                                </div>
                                            </div>
                                        </div>



                                        <div className="row">
                                            <div className="col"><b>Instructions for Inspector <em>(if any)</em> :</b></div>
                                            <div className="col">{value.CallComments ? value.CallComments : 'None'}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col"><b>Action</b></div>
                                            <div className="col">Qty ({this.state.InspectedQty})</div>
                                        </div>

                                        <div className="row">
                                            <div className="col"><b>Accepted :</b></div>
                                            <div className="col">
                                                <Form.Control type="text" name="Quantity" placeholder="Enter Quantity" value={this.state.AcceptedQuantity} onChange={(e) => { this.handleAcceptedQuantity(e, value.InspectionQuantity, value.Unit) }} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col"><b>Rejected :</b></div>
                                            <div className="col">
                                                <Form.Control type="text" name="Quantity" placeholder="Enter Quantity" value={this.state.RejectedQuantity} onChange={(e) => { this.handleRejectedQuantity(e, value.InspectionQuantity, value.Unit) }} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col"><b>Rework Reoffer :</b></div>
                                            <div className="col">
                                                <Form.Control type="text" name="Quantity" placeholder="Enter Quantity" value={this.state.ReworkReofferQty} onChange={(e) => { this.handleReworkReofferQty(e, value.InspectionQuantity, value.Unit) }} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col"><b>Rework Compliance :</b></div>
                                            <div className="col">
                                                <Form.Control type="text" name="Quantity" placeholder="Enter Quantity" value={this.state.ReworkComplainceQty} onChange={(e) => { this.handleReworkComplainceQty(e, value.InspectionQuantity, value.Unit) }} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col"><b>Supplier not ready :</b></div>
                                            <div className="col">
                                                <Form.Control type="text" name="Quantity" placeholder="Enter Quantity" value={this.state.SupplierNotReadyQty} onChange={(e) => { this.handleSupplierNotReadyQty(e, value.InspectionQuantity, value.Unit) }} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col"><b>Inspection not completed :</b></div>
                                            <div className="col">
                                                <Form.Control type="text" name="Quantity" placeholder="Enter Quantity" value={this.state.InspectionNotCompletedQty} onChange={(e) => { this.handleInspectionNotCompletedQTY(e, value.InspectionQuantity, value.Unit) }} />
                                            </div>
                                        </div>
                                        {/* <div className="row pt-2">
                                            <div className="col"><b>Update Status  :</b></div>
                                            <div className="col"> */}
                                        {/* <Dropdown selectedValue={this.state.dropdown}  data={this.state.Status} keyObjName={"id"} valueObjName={"name"}/>   */}
                                        {/* <DropdownFlat defaultopt="Select Option" data={Status} actions={this.handleSelect} keyObjName={"label"} valueObjName={"label"} />
                                            </div>
                                        </div> */}
                                        {/* <div className="row pt-2">
                                            <div className="col"><b>Next Planned Date  :</b></div>
                                            <div className="col">
                                                <Form.Group controlId="dob">
                                                    <Form.Control type="date" name="dob" placeholder="Date" value={this.state.nextPlannedDate} onChange={this.nextPlannedDate} />
                                                </Form.Group>

                                            </div>
                                        </div> */}
                                        <div className="row">
                                            <div className="col"><b>Comments <em>(if any)</em> :</b></div>
                                            <div className="col"><textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea></div>
                                        </div>
                                    </ModalBody>
                                ))}
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer ">
                                <div>
                                    <button className="btn2 btn-sms1 mt-2 ml-4 float-right" disabled={this.state.isUpdateStatus} onClick={this.updateStatus} type="submit">Save</button>


                                </div>


                            </ModalFooter>
                        </div>
                    </div>
                </Modal>


                {/* ----Modal End-------- */}
                {
                    inspectionLineItemDetailsByCallID.map((value, index) => (

                        <div className=" container-fluid p-4" style={{ opacity: this.state.opacity }} >
                            <div className="row pt-2 ">
                                <div className="col-md-6 header">
                                    <b> Inspection Details </b>
                                </div>
                                <div className="col-md-6 ">
                                    {
                                        value.IsActive && value.IsAccepted ?
                                            AuthHandlerInstance.getUserID() == value.InspectorId ?
                                                <button className="btn2 btn-sms1  float-right" type="submit" onClick={this.modal}> Update Inspection Status</button>
                                                : null
                                            : null
                                        // hidden={this.state.buttonvisibility ? false:true}
                                    }
                                </div>
                            </div>
                            <div className=" container-fluid border border-dark">
                                <div className="row ml-2 ">
                                    <div className="col-md-6 pt-2 " >
                                        <div className="row">
                                            <div className="col" ><b>PO No. :</b></div>
                                            <div className="col">{value.POSAPId}</div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col" ><b>Item No. :</b></div>
                                            <div className="col ">{value.POLineItemSAPCode}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row ml-2">
                                    <div className="col-md-6 pt-2 ">
                                        <div className="row">
                                            <div className="col " ><b>PO Date. :</b></div>
                                            <div className="col ">{dateFormater(value.POCreationDate)}</div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col " ><b>Item Delivery Date :</b></div>
                                            <div className="col ">{value.PODeliveryDate ? dateFormater(value.PODeliveryDate) : '----'}</div>
                                        </div>

                                    </div>
                                </div>
                                <div className="row ml-2">
                                    <div className="col-md-6 pt-2 ">
                                        <div className="row">
                                            <div className="col " ><b>Supplier Name :</b></div>
                                            <div className="col ">{value.VendorName}</div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col " ><b>Inspection Call No. :</b></div>
                                            <div className="col ">{value.InspectionCallNo}</div>
                                        </div>

                                    </div>
                                </div>

                                <div className="row ml-2 ">
                                    <div className="col-md-6 pt-2 " >
                                        <div className="row">
                                            <div className="col" ><b>Total PO Quantity :</b></div>
                                            <div className="col ">{value.POLineItemQuantity + " " + value.Unit}</div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col" ><b>Requested Quantity :</b></div>
                                            <div className="col ">{value.InspectionQuantity + " " + value.Unit}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row ml-2">
                                    <div className="col-md-6 pt-2">
                                        <div className="row">
                                            <div className="col-md-6" ><b>Accepted Quantity :</b></div>
                                            <div className="col-md-4">
                                                <input type="text" className="form-control" value={value.AcceptedQuantity ? value.AcceptedQuantity + " " + value.Unit : 0 + " " + value.Unit} readOnly />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 ">
                                        <div className="row ">
                                            <div className="col-md-6 pt-2"><b>Pending Quantity  :</b></div>
                                            <div className="col-md-4">
                                                <input type="text" className="form-control" value={value.AcceptedQuantity ? (parseFloat(value.TotalQuantity) - parseFloat(value.icqty)) + " " + value.Unit : value.PendingQuantity ? (value.PendingQuantity + " " + value.Unit) : '0 ' + value.Unit} readOnly />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row ml-2">
                                    <div className="col-md-6 pt-2">
                                        <div className="row">
                                            <div className="col-md-6" ><b>Rejected Quantity :</b></div>
                                            <div className="col-md-4">
                                                <input type="text" className="form-control" value={value.RejectedQuantity ? (value.RejectedQuantity) + " " + value.Unit : '0 ' + value.Unit} readOnly />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 ">
                                        <div className="row ">
                                            <div className="col-md-6 pt-2"><b>Rework Reoffer Quantity  :</b></div>
                                            <div className="col-md-4">
                                                <input type="text" className="form-control" value={value.ReworkReofferQty ? (value.ReworkReofferQty) + " " + value.Unit : '0 ' + value.Unit} readOnly />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row ml-2">
                                    <div className="col-md-6 pt-2">
                                        <div className="row">
                                            <div className="col-md-6" ><b>Rework Compliance Quantity :</b></div>
                                            <div className="col-md-4">
                                                <input type="text" className="form-control" value={value.ReworkComplainceQty ? (value.ReworkComplainceQty) + " " + value.Unit : '0 ' + value.Unit} readOnly />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 ">
                                        <div className="row ">
                                            <div className="col-md-6 pt-2"><b>Supplier Not Ready Quantity  :</b></div>
                                            <div className="col-md-4">
                                                <input type="text" className="form-control" value={value.SupplierNotReadyQty ? (value.SupplierNotReadyQty) + " " + value.Unit : '0 ' + value.Unit} readOnly />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row ml-2">

                                    <div className="col-md-6 pt-2">
                                        <div className="row ">
                                            <div className="col-md-6 pt-2"><b>Inspection not completed  :</b></div>
                                            <div className="col-md-4">
                                                <input type="text" className="form-control" value={value.InspectionNotCompletedQty ? (value.InspectionNotCompletedQty) + " " + value.Unit : '0 ' + value.Unit} readOnly />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ">
                                        <div className="row ">
                                            <div className="col-md-6 pt-2"></div>
                                            <div className="col-md-4">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row ml-2">
                                    <div className="col-md-6 pt-2 ">
                                        <div className="row">
                                            <div className="col " ><b>Location :</b></div>
                                            <div className="col ">{value.Location}</div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col " ><b>Proposed Inspection Date :</b></div>
                                            <div className="col ">{dateFormater(value.VendorProposedDate)}</div>
                                        </div>

                                    </div>
                                </div>
                                <div className="row ml-2">
                                    <div className="col-md-6 pt-2 ">
                                        <div className="row">
                                            <div className="col " ><b>Stage / Final :</b></div>
                                            <div className="col ">{value.CallItemType === 'RW' ? (<b>Rework</b>) : value.CallItemType === 'RV' ? (<b>Revisit</b>) : value.CallItemType === 'RJ' ? (<b>Rejected</b>) : ''} {(value.QATemplateStageId == 0 ? 'Final' : 'Stage')}</div>
                                        </div>

                                    </div>
                                </div>
                                {/* <div className="row ml-2">
                        <div className="col-md-6 pt-2 ">
                        <div className="row">
                                <div className="col " ><b>Status :</b></div> 
                                <div className="col ">{value.Status}</div>    
                            </div>
                            
                        </div>
                    </div> */}
                                <div className="row ml-2">
                                    <div className="col-md-6 pt-2 ">
                                        <div className="row">
                                            <div className="col " ><b>Item Description :</b></div>
                                            <div className="col ">{value.POLineItemDescription}</div>
                                        </div>

                                    </div>
                                </div>
                                <div className="row ml-2">
                                    <div className="col-md-6 pt-2 ">
                                        <div className="row">
                                            <div className="col " ><b>Inspector Name :</b></div>
                                            <div className="col ">{value.InspectorName}</div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col " ><b>Allocated Inspection Date :</b></div>
                                            <div className="col ">{value.InspectionDate ? dateFormater(value.InspectionDate) : "NA"}</div>
                                        </div>

                                    </div>
                                </div>
                                <div className="row ml-2">
                                    <div className="col-md-6 pt-2  " >
                                        <div className="row">
                                            <div className="col-md-6 " ><b>Instructions for Inspector  <em>(if any)</em>  : </b> </div>
                                            <div className="col-md-6 ">{value.CallComments ? value.CallComments : "NA"}</div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col " ><b>Next Proposed Date :</b></div>
                                            <div className="col ">{value.NextPlannedDate ? dateFormater(value.NextPlannedDate) : "NA"}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row ml-2">
                                    {/* <div className="col-md-6">
                           <div className="row">
                                <div className="col " ><b>Call Status :</b></div> 
                                <div className="col ">{value.CallStatus ? value.CallStatus : "NA"}</div>    
                            </div>
                        </div> */}
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col " ><b>Comments :</b></div>
                                            <div className="col ">{value.Comments ? value.Comments : 'None'}</div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col " ><b>Inspection Comments :</b></div>
                                            <div className="col ">{value.InspectionComment ? value.InspectionComment : 'None'}</div>
                                        </div>
                                    </div>

                                </div>

                                <div className="Container-fluid ">
                                    <div className="row-ml-6  pt-4  " style={{ fontWeight: 1000 }}>
                                        <Alert key={1} variant={'dark'}>
                                            <span className='col-md-8'>All Available Approved QA Documents Provided by Supplier &nbsp; &nbsp;</span>
                                            <span className='col-md-2'>
                                                <Link to={{ pathname: '/InspectiondashboardDocument', state: { poid: value.PurchaseOrderId, itemNo: value.POLineItemSAPCode, po: value.PurchaseOrderId, polineitemID: value.PurchaseOrderLineId } }}>
                                                    <FontAwesomeIcon icon={"eye"} title="View" color={"black"} size="lg" />
                                                </Link>
                                            </span>
                                            <span className='col-md-2'>

                                                <Link className="pr-2" to={{ pathname: '/ExpeditingPOAcceptanceTrail', state: { poId: value.PurchaseOrderId, POSAPId: value.POSAPId, lineItemID: value.PurchaseOrderLineId, lineItemSAPId: value.POLineItemSAPCode } }}>
                                                    <FontAwesomeIcon icon={"sign-in-alt"} color="black" title="View Expediting PO Trail" size="lg" />
                                                </Link>
                                            </span>
                                        </Alert>
                                    </div>
                                </div>
                                <div className="Container-fluid ">
                                    <div className="row-ml-6  pt-4  " style={{ fontWeight: 1000 }}>
                                        <b>Documents To Be Uploaded By Inspector After Inspection (If Applicable) :</b>
                                    </div>
                                    <div className="row ml-2 pt-2">
                                        {this.state.docarr.map((item, i) =>
                                            <div className="col-md-6  ">
                                                <div className="row ">
                                                    <div className="col pt-2 "><b>{item.documentName} :</b></div>
                                                    <div className="col">
                                                        {
                                                            value.IsActive == 0 ?
                                                                AuthHandlerInstance.getUserID() == value.InspectorId ?
                                                                    <div className="form-group pt-2 float-right">
                                                                        <input type="file" className="form-control-file" id="exampleFormControlFile1" onChange={(e) => { this.handleFileInput(e, item.documentTypeId, documentUploadId25) }} />
                                                                    </div>
                                                                    : null
                                                                : null
                                                        }
                                                        {
                                                            this.props.inspectionReducerData.documentData.recordset && this.props.inspectionReducerData.documentData.recordset.length > 0 && this.props.inspectionReducerData.documentData.recordset.find((e) => e.DocumentTypeId == item.documentTypeId) ?
                                                                <div className='row'>
                                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.props.inspectionReducerData.documentData.recordset.find((e) => e.DocumentTypeId == item.documentTypeId).DocumentUploadId + "/download"} target="_blank" download>
                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"download"} color={"black"} title="Download" size="2x" />
                                                                    </a>
                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"code-branch"} color={"black"} title="Document Version" size="2x" onClick={() => this.OpenVersionModal(this.props.inspectionReducerData.documentData.recordset.find((e) => e.DocumentTypeId == item.documentTypeId).DocumentUploadId)} />
                                                                    {roles[3] ?
                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"grey"} title="Revise" size="2x" />
                                                                        : null}
                                                                </div>
                                                                : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>)}
                                        <div className="col-md-6 pt-2  ">
                                            <div className="row ">
                                                <div className="col pt-2 "><b>CSMT Link :</b></div>
                                                <div className="col">
                                                    {AuthHandlerInstance.getUserID() == value.InspectorId ?
                                                        <Form.Control type="text" name="csmtlink" placeholder="Enter CSMT Link" value={this.state.CSMTLink} onChange={(e) => { this.handleCSMTLink(e) }} />
                                                        :
                                                        this.state.CSMTLink ?
                                                            <a href={this.state.CSMTLink} target="_blank">Go to CSMT Link</a>
                                                            : ''
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 pt-2  ">
                                            {
                                                value.IsActive == 0 ?
                                                    AuthHandlerInstance.getUserID() == value.InspectorId ?
                                                        <button className="btn2 btn-sms1 mt-2 mb-2 ml-4 float-right" hidden={this.state.CSMTLink ? false : true} type="submit" onClick={this.saveCSMTLink}>Save Link</button>
                                                        : null
                                                    : null
                                            }
                                        </div>
                                        <div className="col-md-12 pt-2  ">
                                            {
                                                value.IsActive == 0 ?
                                                    AuthHandlerInstance.getUserID() == value.InspectorId ?
                                                        <button className="btn2 btn-sms1 mt-2 mb-2 ml-4 float-right" hidden={this.state.files.length > 0 ? false : true} type="submit" onClick={this.saveFiles}>Save </button>
                                                        : null
                                                    : null
                                            }
                                        </div>

                                    </div>
                                </div>


                            </div>


                        </div>
                    ))
                }



            </div>





        )
    }

}


const mapStateToProps = (state) => ({ inspectionReducerData: state.inspectionReducer, masterReducerData: state.masterReducer, file: state.file })
export default connect(mapStateToProps, { getCallLineItemDetailsById, getInspectionStatusMaster, createReworkReofferCallItem, patchUpdateInspectionStatus, uploadInspectionFiles, downloadFile, getAllDocumentsUploadedByInpsector, uploadInspectionCSMTLink, getPODetails, getPOSearch, postSaveStagesForLineItemPO, postEditStagesForLineItemPO })(InspectorDetails)